/* VOSTA sign-up popup (09/10/2026). Markup: snippets/vosta-popup.liquid. Settings: Theme settings → VOSTA sign-up popup.
   Street & Track sign-ups join "Website Popup" (RcJwwE), 4WD sign-ups join "Website Popup – 4WD" (WcBuN6); each list starts
   its own Welcome flow (5% code POPUP5). Same public client API as the footer sign-up. Nothing else is stored. */
(() => {
  const el = document.getElementById('vpop'); if (!el) return;
  const KEY = 'vosta-popup', COMPANY = 'Sn6aF8';
  const SKIP_TPL = /^(cart|password|gift_card|customers\/|page\.(contact|collabs|measure|measure-terms))/;
  const store = { get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
                  set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} } };
  const is4 = () => document.body.dataset.mode === '4wd';
  const q = new URLSearchParams(location.search);
  const force = q.has('vpop');                                   // ?vpop = show now (testing / preview)

  // Already on the list? People arriving from a Klaviyo email carry _kx; Klaviyo's cookie holds their email once identified.
  const known = () => { if (q.has('_kx')) return true;
    const c = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
    if (!c) return false; try { const k = JSON.parse(atob(decodeURIComponent(c[1]))); return !!(k.$email || k.$exchange_id); } catch (e) { return false; } };

  const st = store.get(), days = +el.dataset.days || 14;
  if (!force) {
    if (st.joined || known()) { if (!st.joined && known()) store.set({ joined: true, at: Date.now() }); return; }
    if (st.closed && Date.now() - st.closed < days * 864e5) return;
    if (SKIP_TPL.test(el.dataset.tpl || '')) return;
  }

  // Wait while anything else is open, including a Klaviyo signup-form popup (the old live form UPXhH4 until it's switched off at launch).
  const busy = () => document.body.classList.contains('lock') || document.body.classList.contains('klaviyo-prevent-body-scrolling')
    || document.querySelector('.drawer.open,.search.open,.modal.open,.aipanel.open');
  let shown = false, lastFocus = null;
  const show = () => {
    if (shown) return; if (busy()) { setTimeout(show, 2500); return; }
    shown = true; lastFocus = document.activeElement; el.hidden = false; document.body.classList.add('vpop-lock');
    requestAnimationFrame(() => { el.classList.add('open'); setTimeout(() => { const i = el.querySelector('input'); if (i && matchMedia('(min-width:701px)').matches) i.focus({ preventScroll: true }); }, 320); });
  };
  const close = () => {
    if (!el.classList.contains('open')) return;
    if (!store.get().joined) store.set({ closed: Date.now() });
    el.classList.remove('open'); document.body.classList.remove('vpop-lock');
    setTimeout(() => { el.hidden = true; if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }, 260);
  };

  el.addEventListener('click', e => { if (e.target === el || e.target.closest('[data-vpop-close]')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && el.classList.contains('open')) close(); });

  const form = el.querySelector('form'), inp = form.querySelector('input'), err = form.querySelector('.vpop-err'), btn = form.querySelector('button');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const email = inp.value.trim(), ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    inp.classList.toggle('bad', !ok); err.textContent = ok ? '' : 'That email doesn’t look right.';
    if (!ok) { inp.focus(); return; }
    const list = is4() ? el.dataset.listOffroad : el.dataset.listStd;
    btn.disabled = true; const label = btn.textContent; btn.textContent = 'Sending…';
    const body = { data: { type: 'subscription', attributes: {
      custom_source: is4() ? 'VOSTA 4WD site popup' : 'VOSTA site popup',
      profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
    }, relationships: { list: { data: { type: 'list', id: list } } } } };
    try {
      const r = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY, { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
      if (!r.ok) throw new Error(r.status);
      store.set({ joined: true, at: Date.now() });
      try { if (window.klaviyo && klaviyo.identify) klaviyo.identify({ email }); else if (window._learnq) _learnq.push(['identify', { $email: email }]); } catch (_) {}
      el.querySelector('[data-vpop-done]').textContent = `Your 5% code is on its way to ${email}. Not there in a few minutes? Check your promotions folder.`;
      el.querySelectorAll('[data-vpop-step]').forEach(s => s.classList.toggle('on', s.dataset.vpopStep === '2'));
    } catch (_) {
      err.textContent = 'Something went wrong. Give it another go in a moment.'; btn.disabled = false; btn.textContent = label;
    }
  });

  // When (09/10/2026, set for conversion): time on SITE, not per page, counted only while the tab is visible (sessionStorage).
  //  Desktop: 12s on site, or earlier on exit intent once they've been here 5s.
  //  Phones: 25s on site, or 5s into their 2nd page. Never on the first screen of a phone landing (Google's mobile interstitial rule).
  if (force) { show(); return; }
  const ss = { get(k) { try { return +sessionStorage.getItem(k) || 0; } catch (e) { return 0; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };
  const phone = !matchMedia('(pointer:fine)').matches;
  const pv = ss.get('vosta-popup-pv') + 1; ss.set('vosta-popup-pv', pv);
  const need = ((phone ? +el.dataset.delayM : +el.dataset.delay) || (phone ? 25 : 12)) * 1000;
  let spent = ss.get('vosta-popup-ms'), here = 0;
  const tick = setInterval(() => {
    if (shown) { clearInterval(tick); return; }
    if (document.visibilityState !== 'visible') return;
    spent += 1000; here += 1000; ss.set('vosta-popup-ms', spent);
    if (spent >= need || (phone && pv >= 2 && here >= 5000)) { clearInterval(tick); show(); }
  }, 1000);
  if (!phone) document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0 && spent >= 5000) show(); });
})();
